/**
 * Strip legacy fields from form data that linger after migration.
 * The old single-property 'property' object is superseded by the 'properties[]' array.
 */
export function stripLegacyFields(formData: Record<string, unknown>): Record<string, unknown> {
  if (Array.isArray(formData.properties) && formData.properties.length > 0 && 'property' in formData) {
    const cleaned = { ...formData };
    delete cleaned.property;
    return cleaned;
  }
  return formData;
}

